document.addEventListener("click", (event) => {
  const target =
    event.target.closest("[data-mobile-menu-container]") ||
    event.target.closest("[data-mobile-menu-trigger]");

  if (!target) {
    closeMobileMenu();
  }
});

const mobileMenuTrigger = document.querySelector("[data-mobile-menu-trigger]");

if (mobileMenuTrigger) {
  mobileMenuTrigger.addEventListener("click", (e) => {
    e.preventDefault();

    const container = mobileMenuTrigger.closest("[data-mobile-menu-container]");
    const menu = container.querySelector("[data-mobile-menu]");
    const iconOpen = container.querySelector("[data-mobile-menu-icon-open]");
    const iconClose = container.querySelector("[data-mobile-menu-icon-close]");

    const isHidden = menu.classList.toggle("hidden");
    iconOpen.classList.toggle("hidden", !isHidden);
    iconClose.classList.toggle("hidden", isHidden);

    mobileMenuTrigger.setAttribute("aria-expanded", !isHidden);
  });
}

const closeMobileMenu = () => {
  const menu = document.querySelector("[data-mobile-menu]");
  const iconOpen = document.querySelector("[data-mobile-menu-icon-open]");
  const iconClose = document.querySelector("[data-mobile-menu-icon-close]");
  const trigger = document.querySelector("[data-mobile-menu-trigger]");

  if (menu) {
    menu.classList.add("hidden");
    iconOpen?.classList.remove("hidden");
    iconClose?.classList.add("hidden");
    trigger?.setAttribute("aria-expanded", "false");
  }
};
